<template>
  <div class="project-template">
    <div class="project-template-title">{{ title }}</div>
    <div class="project-template-left">
      <div class="left-content" :class="{ 'need-52px': oneClickProject }">
        <slot name="leftContent"></slot>
      </div>
      <div class="btn-list">
        <a-button-group style="margin-bottom: 20px;" v-if="oneClickProject">
          <a-button type="primary" class="btn3" @click="oneClick">
            一键生成方案
          </a-button>
        </a-button-group>        
        <a-button-group>
          <!-- <component :is="customIcon" fontSize="30px" ></component> -->
          <a-button class="btn1" @click="$emit('lastClick')">上一步</a-button>
          <a-button type="primary" class="btn2" @click="$emit('nextClick')">
            {{ nextBtnText }}
          </a-button>
        </a-button-group>
      </div>
    </div>
    <div class="project-template-right">
      <div class="right-content">
        <slot name="rightContent"></slot>
      </div>
    </div>
    <scheme-model ref="schemeModel" @gotoPageClick="gotoPageClick"></scheme-model>
  </div> 
</template>

<script>
import IconBack from '@comp/Icon/IconBack'
import AIHelper from '@comp/Icon/AIHelper'
import SchemeModel from '@views/apppad/projectTemplate/SchemeModel.vue'
export default {
  name: 'ProjectTemplate',
  components: { IconBack, AIHelper, SchemeModel },
  props: {

    // leftTitle: {
    //   type: String,
    //   default: '标题1'
    // },
    title: {
      type: String,
      required: true,
      default: '标题'
    },
    nextBtnText: {
      type: String,
      default: '下一步'
    },
    oneClickProject: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      customIcon: 'ai-helper' // 替换为你的自定义图标类名
    };
  },
  methods: {
    oneClick() {
      const id = this.$route.query.id
      console.log('点击了一键生成方案: ', id)
      //获取知识库方案
      this.$refs.schemeModel.initData(id)
    },
    gotoPageClick(page){
      console.log('点击了跳转页面: ', page)
      this.$emit('gotoPage', page)
    }
  }

}
</script>

<style scoped lang="less">
.project-template {
  display: grid;
  grid-template-columns: 375px calc(100vw - 92px - 375px);
  grid-template-rows: 56px calc(100vh - 56px);
}

.project-template-title {
  grid-column-start: 1;
  grid-column-end: 3;
  border-left: 1px solid rgba(255, 255, 255, 0.3);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
  color: white;
}

.project-template-left {
  position: relative;
  border-left: 1px dashed rgba(255, 255, 255, 0.3);
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  overflow-y: auto;

  .left-content {
    padding: 20px;
    height: calc(100vh - 56px - 72px);
    overflow: auto
  }
  .left-content.need-52px {
    height: calc(100vh - 56px - 72px - 52px);
  }

  .btn-list {
    padding: 20px 0;
    text-align: center;

    .icon {
      padding: 0 30px;
      color: white;
      background: rgba(255, 255, 255, 0.15);
      border: none;
      border-radius: 21px 0 0 21px !important;
    }

    .btn1 {
      padding: 0 30px;
      color: white;
      background: rgba(255, 255, 255, 0.15);
      border: none;
      border-radius: 21px 0 0 21px !important;
    }

    .btn2 {
      padding: 0 30px;
      color: white;
      background: linear-gradient(90deg, #376EFF 0%, #DE5DFE 100%);
      border: none;
      border-radius: 0 21px 21px 0 !important;
    }
    .btn3 {
      padding: 0 30px;
      color: white;
      background: linear-gradient(90deg, #376EFF 0%, #DE5DFE 100%);
      border: none;
      border-radius: 21px;
    }
  }
}

.project-template-right {
  background: url(~@/assets/bg02.png) center center no-repeat;

  .right-content {
    padding: 20px;
    height: calc(100vh - 56px);
    overflow: auto;
    position: relative;
  }
}
</style>
